import React from 'react';
import { expenseTotal } from './expenseItems';

const BLANK = { item: '', link: '', amount: '' };

export function ExpenseItemsEditor({ items = [], onChange }) {
  const update = (i, field, value) =>
    onChange(items.map((r, idx) => (idx === i ? { ...r, [field]: value } : r)));
  const addRow = () => onChange([...items, { ...BLANK }]);
  const removeRow = (i) => onChange(items.filter((_, idx) => idx !== i));

  return (
    <section className="expense-items" aria-label="Expenses">
      <h4>Expenses</h4>
      <table className="kpi-bundle-table expense-items-table">
        <thead>
          <tr>
            <th>Item *</th><th>Link</th><th>Amount, USD *</th>
            <th><span className="sr-only">Remove</span></th>
          </tr>
        </thead>
        <tbody>
          {items.map((r, i) => (
            <tr key={i}>
              <td><input type="text" aria-label={`item ${i + 1}`} maxLength={200} value={r.item}
                onChange={(e) => update(i, 'item', e.target.value)} /></td>
              <td><input type="text" aria-label={`link ${i + 1}`} maxLength={200} value={r.link}
                onChange={(e) => update(i, 'link', e.target.value)} /></td>
              <td><input type="number" min="0" step="any" aria-label={`amount ${i + 1}`} value={r.amount}
                onChange={(e) => update(i, 'amount', e.target.value)} /></td>
              <td><button type="button" className="btn-secondary" aria-label={`remove item ${i + 1}`}
                onClick={() => removeRow(i)}>✕</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="btn-secondary" onClick={addRow}>+ Add item</button>
      <p className="expense-total"><strong>Total (USD):</strong> <span data-testid="expense-total">{expenseTotal(items).toLocaleString('en-US')}</span></p>
    </section>
  );
}
